import { NextSeo } from 'next-seo'
import styled from 'styled-components'
import DefaultPageLayout from '~/components/templates/DefaultPageLayout'

export default function ClosePage() {
  return (
    <DefaultPageLayout>
      <NextSeo
        title='サービス終了のお知らせ'
        openGraph={{
          url: `${process.env.origin}/close`,
          title: 'サービス終了のお知らせ - Ambass'
        }}
      />
      <Title>サービス終了のお知らせ</Title>
      <Container>
        <Row>
          <Description>
            いつもご利用ありがとうございます。
            <br />
            Ambassサポートチームです。
            <br />
            <br />
            このたび、決済システムの提供方針変更により、誠に残念ながら「Ambass」は2025年12月31日をもって、サービスを終了させていただくことになりました。
            <br />
            <br />
            長らくのご愛顧に心より感謝申し上げます。
            <br />
            重要なご案内を以下にまとめましたので、必ずご確認ください。
          </Description>
        </Row>
        <Row>
          <Header>サービス終了日について</Header>
          <Description>
            ■サービス終了日
            <br />
            2025年12月31日（予定）
            <br />
            <br />
            ※サービス終了後は、すべての機能（販売・購入・ダウンロードなど）がご利用いただけなくなります。
          </Description>
        </Row>
        <Row>
          <Header>購入・プレゼントされた作品のダウンロードについて</Header>
          <Description>
            サービス終了後は、購入済みまたは布教された作品のダウンロードができなくなります。
            <br />
            <br />
            それらの作品は、必ず終了日までにご自身でダウンロードをお願いいたします。
          </Description>
        </Row>
        <Row>
          <Header>売上の振込申請について（クリエイターの方向け）</Header>
          <Description>
            売上がある方は、終了日までに必ず振込申請を行ってください。サービス終了後は売上が消失し、申請ができなくなります。
            <br />
            <br />
            ※なお、振込手数料として300円が発生いたします。そのため、売上が301円未満の方は振込申請ができず、売上が消失しますことをご了承ください。
          </Description>
        </Row>
        <Row>
          <Header>ユーザーデータ・アップロードコンテンツの削除について</Header>
          <Description>
            サービス終了後、「Ambass」に登録されたすべての個人情報およびアップロードされた作品データは、運営チームにて安全に削除いたします。
            <br />
            <br />
            削除後は、再発行・復元などは一切できませんので、ご注意くださいませ。
          </Description>
        </Row>
        <Row>
          <Header>詳細・お問い合わせ</Header>
          <Description>
            ご不明点がございましたら、以下サポート窓口までお問い合わせください。
            <br />
            <br />
            📩 support@ambass.me
          </Description>
        </Row>
        <Row>
          <Description>
            これまで「Ambass」をご愛顧いただき、本当にありがとうございました。
            <br />
            皆さまの創作活動がこれからも素晴らしい形で続いていくことを、心から願っております。
          </Description>
        </Row>
      </Container>
    </DefaultPageLayout>
  )
}

const Title = styled.h1`
  text-align: center;
  margin: 40px 24px;
  ${({ theme }) => theme.fonts.Bold20};
  color: ${({ theme }) => theme.colors.OnSurface2};
`

const Container = styled.div`
  display: grid;
  grid-gap: 24px;
`

const Row = styled.div``

const Header = styled.h2`
  margin-bottom: 16px;
  ${({ theme }) => theme.fonts.Bold20};
  color: ${({ theme }) => theme.colors.OnSurface5};
`

const Description = styled.p`
  ${({ theme }) => theme.fonts.Bold16};
  color: ${({ theme }) => theme.colors.OnSurface2};
  margin-bottom: 8px;
`
